import {
  PopoverMenu,
  PopoverMenuItem,
  PopoverMenuSeparator,
} from '@ui/components/PopoverMenu/PopoverMenu';

import { IValidRoute } from '@features/shared/utils/router';
import { UserSettingsProps } from '@features/user/hooks/useUserSettings';

import { SiteSettingsMenuItems } from '../SiteSettingsItems/SiteSettingsMenuItems';

type Props = {
  className?: string;
  isOpen: boolean;
  settings?: UserSettingsProps;
  onClose: () => void;
};

export function UserSettingsMenuPopover({ className, isOpen, onClose, settings }: Props) {
  const linkFriend: IValidRoute = '/game/friend';
  const linkClubs: IValidRoute = '/club';
  const linkEvents: IValidRoute = '/tournament';
  const linkPairing: IValidRoute = '/game/pairing';
  const linkComputer: IValidRoute = '/game/computer';
  const linkAnalysis: IValidRoute = '/game/analysis';

  return (
    <PopoverMenu className={className} isOpen={isOpen} onClose={onClose}>
      <PopoverMenuItem href={linkFriend}>Игра с другом</PopoverMenuItem>
      <PopoverMenuItem href={linkClubs}>Шахматные клубы</PopoverMenuItem>
      <PopoverMenuItem href={linkEvents}>Онлайн-турниры</PopoverMenuItem>
      <PopoverMenuItem href={linkPairing}>Поиск соперника</PopoverMenuItem>
      <PopoverMenuItem href={linkComputer}>Игра с компьютером</PopoverMenuItem>
      <PopoverMenuItem href={linkAnalysis}>Анализ партии</PopoverMenuItem>
      <PopoverMenuSeparator />
      <PopoverMenuItem inNewTab href="https://chessopen.ru/live/">
        Трансляции
      </PopoverMenuItem>
      <PopoverMenuItem inNewTab href="https://chessopen.ru/">
        Портал ChessOpen
      </PopoverMenuItem>
      <PopoverMenuItem inNewTab href="https://chessopen.ru/tournaments/">
        Поиск оффлайн турниров
      </PopoverMenuItem>
      {settings && (
        <>
          <PopoverMenuSeparator />
          <SiteSettingsMenuItems {...settings} />
        </>
      )}
    </PopoverMenu>
  );
}
